/**
 * Layout Slider
 * based on Flickity
 */

(function ($) {

    // Toggle console debug output
    var sliderDebug = false;

    // Elements
    var $sliderElement = $('.js-slider');
    var sliderParentClass = '.js-slider__parent';
    var sliderNavContainerClass = '.js-slider__nav-container';
    var sliderCellClass = '.js-slider__cell';

    // Slider function
    function slider() {

        // Iterate over each slider
        $sliderElement.each(function(i) {
            var $this = $(this);

            // Add debug class
            if (sliderDebug) {
                $this.addClass('js-slider--debug')
            }

            // Counter for console outpout
            var sliderCount = i + 1;

            // Some numbers
            var sliderTotalCells = $this.find(sliderCellClass).length;
            var sliderWidth = $this.width();
            var sliderCellWidth = $this.parents(sliderParentClass).find(sliderCellClass).outerWidth();
            var sliderVisibleCells = Math.round(sliderWidth / sliderCellWidth);

            // Some navigation related elements
            var $sliderParent = $this.parents(sliderParentClass);
            var $sliderNavContainer = $sliderParent.find(sliderNavContainerClass);

            // Only activate the slider when there are more cells
            // than cells fitting into the visible slider container.
            // (The magic number "+ 3" compensates browser rounding issues.)
            var activateSlider = sliderCellWidth * sliderTotalCells > sliderWidth + 3;

            // Activate slider
            if (activateSlider && !$this.hasClass('flickity-enabled')) {
                var $sliderNavPrev = $sliderParent.find('.js-slider__nav-prev');
                var $sliderNavNext = $sliderParent.find('.js-slider__nav-next');

                if (sliderDebug) { console.log("Initiate Slider #" + sliderCount); }

                // Initialize Flickity with jQuery
                var $slider = $this.flickity({
                    cellSelector: sliderCellClass,
                    cellAlign: 'left',
                    contain: true,
                    setGallerySize: true,
                    imagesLoaded: true,
                    percentPosition: true,
                    prevNextButtons: false,
                    pageDots: false
                });

                // Get Flickity instance
                var flkty = $this.data('flickity');

                // Add nav prev element
                if ($sliderNavPrev.length == 0) {
                    $sliderNavContainer
                        .addClass('has-slider__nav-prev');
                    $sliderNavContainer
                        .append('<span class="c-slider__nav-prev  js-slider__nav  js-slider__nav-prev"><span>previous</span></span>');
                }

                // Add nav next element
                if ($sliderNavNext.length == 0) {
                    $sliderNavContainer
                        .addClass('has-slider__nav-next');
                    $sliderNavContainer
                        .append('<span class="c-slider__nav-next  js-slider__nav  js-slider__nav-next"><span>next</span></span>');
                }

                // Nav prev functionality
                $sliderParent
                    .find('.js-slider__nav-prev')
                    .on( 'click', function() {
                        $(this)
                        .parents(sliderParentClass)
                        .find($sliderElement)
                        .flickity('previous');
                    });

                // Hide nav prev when first cell is visible
                if (flkty.selectedIndex == 0) {
                    $sliderNavContainer
                        .removeClass('has-slider__nav-prev');
                    $sliderParent
                        .find('.js-slider__nav-prev')
                        .addClass('is-disabled');
                }

                // Nav next functionality
                $sliderParent
                    .find('.js-slider__nav-next')
                    .on( 'click', function() {
                        $(this)
                        .parents(sliderParentClass)
                        .find($sliderElement)
                        .flickity('next');
                    });

                // Do stuff when select slider cell
                $this.on( 'cellSelect', function() {

                    // Disable nav next on last group of visible cell
                    if (flkty.selectedIndex >= sliderTotalCells - sliderVisibleCells) {
                        $sliderNavContainer
                            .removeClass('has-slider__nav-next');
                        $sliderParent
                            .find('.js-slider__nav-next')
                            .addClass('is-disabled');
                    }
                    // Enable nav next
                    else {
                        $sliderNavContainer
                            .addClass('has-slider__nav-next');
                        $sliderParent
                            .find('.js-slider__nav-next')
                            .removeClass('is-disabled');
                    }

                    // Disable nav prev
                    if (flkty.selectedIndex == 0) {
                        $sliderNavContainer
                            .removeClass('has-slider__nav-prev');
                        $sliderParent
                            .find('.js-slider__nav-prev')
                            .addClass('is-disabled');
                    }
                    // Enable nav prev
                    else {
                        $sliderNavContainer
                            .addClass('has-slider__nav-prev');
                        $sliderParent
                            .find('.js-slider__nav-prev')
                            .removeClass('is-disabled');
                    }

                    // Update console
                    if (sliderDebug) { sliderDebugConsole(); }

                })

                // Update console
                if (sliderDebug) { sliderDebugConsole(); }

            }

            // Slider enabled? Destroy it!
            else if (!activateSlider && $this.hasClass('flickity-enabled')) {

                // Destroy slider
                $this.flickity('destroy');

                // Remove nav elements
                $sliderNavContainer
                    .removeClass('has-slider__nav-prev');
                $sliderNavContainer
                    .removeClass('has-slider__nav-next');
                $this
                    .parents(sliderParentClass)
                    .find('.js-slider__nav')
                    .remove();

                if (sliderDebug) { console.log('\nHasta la vista, Slider!\n'); }
            }

            // Debug console function
            function sliderDebugConsole() {
                console.log(
                      '\n        Slider: #' + sliderCount
                    + '\n  Slider Width: ' + sliderWidth
                    + '\n    Cell Width: ' + sliderCellWidth
                    + '\n   Total Cells: ' + sliderTotalCells
                    + '\n Visible Cells: ' + sliderVisibleCells
                    + '\nSelected Index: ' + flkty.selectedIndex
                    + '\n '
                );
            }

        });
    };

    // Run the slider function on resize
    $(window).on('resize', function() {
        slider();
        $('.js-slider.flickity-enabled').flickity('resize');
    });

    // Run the slider function after page load
    $(document).ready(function() {
        slider();
    });

})(jQuery);
